<template>
  <div class="warpper">
    <div class="mask" v-show="loading">
      <van-loading size="24px" class="wait">
        <span style="color: #fff">加载中... </span>
      </van-loading>
    </div>
    <div>
      <GlobalHeader
        :chname="diseaseItem.chname"
        :conclusionLevel="diseaseItem.conclusion"
      ></GlobalHeader>
      <GlobalContent
        :diseaseItem="diseaseItem"
        :diseaseInfo="diseaseInfo"
        :diseaseGene="diseaseGene"
        :reference="referenceData"
      ></GlobalContent>
      <GlobalFooter
        :list="footerList"
        :currentId="itemid"
        :currentScode="scode"
      ></GlobalFooter>
    </div>
  </div>
</template>

<script>
import GlobalHeader from "@/components/smallGlobal/GlobalHeader.vue";
import GlobalContent from "@/components/smallGlobal/GlobalContent.vue";
import GlobalFooter from "@/components/smallGlobal/GlobalFooter.vue";
export default {
  components: { GlobalHeader, GlobalContent, GlobalFooter },
  data() {
    return {
      itemid: 0,
      scode: "",
      type: "",
      diseaseItem: {},
      diseaseInfo: {},
      diseaseGene: [],
      referenceData: [],
      footerList: [],
      loading: false,
      historyParams: {},
    };
  },
  watch: {
    loading: {
      handler() {
        document.body.style.overflow = this.loading ? "hidden" : "auto";
      },
    },

    $route() {
      const { id, scode, type } = this.$route.params;
      this.itemid = +id;
      this.scode = scode;
      this.type = type;
      this.handlePrevAndNext();
    },
  },
  methods: {
    fetchItem() {
      // 获取单项数据
      const params = {
        scode: this.scode,
        itemid: this.itemid,
      };
      this.util.smallGet(this.api.diseaseItem, params, (data) => {
        this.diseaseItem = data;
      });
    },
    fetchDeseaseInfo() {
      // 获取疾病详情
      const params = {
        itemid: this.itemid,
      };
      this.util.smallGet(this.api.diseaseInfo, params, (data) => {
        this.diseaseInfo = data;
      });
    },
    fetchDiseaseGene() {
      // 获取解读项基因位点
      const params = {
        scode: this.scode,
        itemid: this.itemid,
      };
      this.util.smallGet(this.api.diseaseGene, params, (data) => {
        this.diseaseGene = data;
      });
    },
    // fetchReference() {
    //   // 获取参考文献
    //   const params = {
    //     scode: this.scode,
    //     itemid: this.itemid,
    //     dsystem: 1,
    //     product_code: this.type,
    //   };
    //   this.util.smallGet(this.api.referenceItem, params, (data) => {
    //     this.referenceData = data;
    //   });
    // },
    fetchDiseaseList() {
      const params = {
        scode: this.scode,
      };
      this.util.smallGet(this.api.diseaseReport, params, (data) => {
        const highArr = [],
          higherArr = [],
          generalArr = [],
          lowerArr = [],
          lowArr = [],
          other = [];
        data.forEach((item) => {
          switch (item.conclusion) {
            case "高风险":
              highArr.push(item);
              break;
            case "较高风险":
              higherArr.push(item);
              break;
            case "一般风险":
              generalArr.push(item);
              break;
            case "较低风险":
              lowerArr.push(item);
              break;
            case "低分险":
              lowArr.push(item);
              break;
            default:
              other.push(item);
              break;
          }
        });
        if (highArr.length > 1) {
          highArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (higherArr.length > 1) {
          higherArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (generalArr.length > 1) {
          generalArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (lowerArr.length > 1) {
          lowerArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (lowArr.length > 1) {
          lowArr.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        if (other.length > 1) {
          other.sort((a, b) => parseFloat(b.risk) - parseFloat(a.risk));
        }
        this.footerList = [
          ...highArr,
          ...higherArr,
          ...generalArr,
          ...lowerArr,
          ...lowArr,
          ...other,
        ];
      });
    },
    fetchData() {
      this.loading = true;
      this.fetchItem();
      this.fetchDeseaseInfo();
      this.fetchDiseaseGene();
      // this.fetchReference();
      setTimeout(() => {
        this.loading = false;
      }, 800);
    },
    handlePrevAndNext() {
      this.fetchData();
      document.documentElement.scrollTop = 0;
    },
  },
  mounted() {
    const { id, scode, type } = this.$route.params;
    this.itemid = +id;
    this.scode = scode;
    this.type = type;
    this.fetchData();
    this.fetchDiseaseList();
  },
};
</script>

<style lang="scss" scoped>
.warpper {
  .mask {
    background-color: rgba(0, 0, 0, 0.2);
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    overflow: hidden;
    .wait {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/smallProduct/deseaseDetails/index.vue